const tournamentIcons = {
    "Premier League": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    "La Liga": "🇪🇸",
    "Serie A": "🇮🇹",
    "World Cup": "🏆",
    "EURO": "🏆",
    "Champions League": "⚽"
};

export default tournamentIcons;